import { PaymentErrors } from 'src/Components/PaymentErrorsAlert'

const PAYPAL_TRANSACTION_REFUSED = 'paypal-transaction-refused'

const getApiErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object' || !('data' in error)) {
    return void 0
  }

  const { data } = error

  if (!data || typeof data !== 'object' || !('message' in data)) {
    return void 0
  }

  return typeof data.message === 'string' ? data.message : void 0
}

export const getOrderCheckoutPaymentError = (error: unknown): PaymentErrors =>
  getApiErrorMessage(error) === PAYPAL_TRANSACTION_REFUSED
    ? PaymentErrors.PAYPAL_TRANSACTION_REFUSED
    : PaymentErrors.DEFAULT
